export const SET_CATEGORY_DATA = 'SET_CATEGORY_DATA';
export const SET_MENU_ITEM_DATA = 'SET_MENU_ITEM_DATA';
export const TOGGLE_IMAGE_MODAL = 'TOGGLE_IMAGE_MODAL';
export const SET_IMAGE_DATA = 'SET_IMAGE_DATA';